export default "__VITE_ASSET__UX2RZxjm__"